import type { ReservationSlotTargetShift } from '../../domain/reservationSlots';
import type { ReservationSlotRepository } from './ports/ReservationSlotRepository';

/**
 * 解放枠の生成対象シフトを取得するUseCase
 *
 * @description
 * 対象月の確定済み医師シフトを取得する。解放枠生成タブの初期表示に使用する。
 *
 * @param {ReservationSlotRepository} repository - Repository実装（DI）
 * @param {number} year - 対象年
 * @param {number} month - 対象月（1-12）
 * @returns {Promise<ReservationSlotTargetShift[]>} 対象シフト配列
 */
export async function getTargetShifts(
  repository: ReservationSlotRepository,
  year: number,
  month: number
): Promise<ReservationSlotTargetShift[]> {
  return repository.findTargetShifts(year, month);
}
